import { cloudFunction } from 'services/parse';

export const createSupplier = (supplierData: Record<string, any>) => {
  return cloudFunction('createSupplier', supplierData);
};

export const updateSupplier = (supplierData: Record<string, any>) => {
  return cloudFunction('updateSupplier', supplierData);
};

export const fetchSupplierDetails = async (id: string) => {
  const response = await cloudFunction('fetchSupplierDetailsForAdmin', { id });
  return response.toJSON();
};

export const fetchUsersForSupplier = (data: Record<string, any>) => {
  return cloudFunction('fetchUsersForSupplier', data);
};

export const fetchUserByEmail = async (email: string) => {
  return cloudFunction('fetchUserByEmail', { email });
};

export const addUserToSupplier = (userId: string, supplierId: string) => {
  return cloudFunction('addUserToSupplier', { userId, supplierId });
};

export const removeUserFromSupplier = (userId: string, supplierId: string) => {
  return cloudFunction('removeUserFromSupplier', { userId, supplierId });
};

export const addScheduleToSupplier = (data: Record<string, any>) => {
  return cloudFunction('addScheduleToSupplier', data);
};

export const createSupplierInventoryMapping = (data) => {
  return cloudFunction('createSupplierInventoryMapping', data);
};

export const fetchAllSupplierInventoryMappingsForAdmin = (supplierId: string) => {
  return cloudFunction('fetchAllSupplierInventoryMappingsForAdmin', { supplierId });
};

export const deleteSupplierInventoryMapping = (id: string) => {
  return cloudFunction('deleteSupplierInventoryMapping', { id });
};

export const updateSupplierInventoryMapping = (data) => {
  return cloudFunction('updateSupplierInventoryMapping', data);
};

export const addSupplierBlog = (data: Record<string, any>) => {
  return cloudFunction('addSupplierBlog', data);
};

export const removeSupplierBlog = (data: Record<string, any>) => {
  return cloudFunction('removeSupplierBlog', data);
};